var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcursionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 70,
    viewBox: "0 0 72 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22",
    "data-name": "Rect\\xE1ngulo 22",
    width: 72,
    height: 70,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_62",
    "data-name": "Trazado 62",
    d: "M0,64.553,22.332,70V28.407L0,22.955ZM35.053,0A12.823,12.823,0,0,0,22.259,12.869c0,5.424,8.081,20.56,12.794,28.69,4.714-8.131,12.794-23.266,12.794-28.69A12.822,12.822,0,0,0,35.053,0M25.4,12.869a9.655,9.655,0,1,1,19.3,0,9.651,9.651,0,1,1-19.3,0M49.67,64.553,72,70V28.407L49.67,22.955Z",
    fill: "#20221d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63",
    "data-name": "Trazado 63",
    d: "M24.768,28.407V70l22.467-5.447v-41.6l-.849.262L35.053,46.889,25.776,28.144Z",
    fill: "#fdb54e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_64",
    "data-name": "Trazado 64",
    d: "M29.44,12.869a5.612,5.612,0,1,0,11.223,0,5.612,5.612,0,1,0-11.223,0",
    fill: "#fdb54e",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcursionIcon);
export default __webpack_public_path__ + "static/media/excursionIcon.0574a04d50851bea2cc9e619c65ab050.svg";
export { ForwardRef as ReactComponent };